import { PropTypes } from 'prop-types';
import styles from './style.m.less';

export default function InputPrefix({ prefix, prefixSize }) {
    const style = {
        width: `${prefixSize}px`,
    };
    return prefix ? (
        <div className={styles.inputPrefix} style={style}>
            {prefix}
        </div>
    ) : null;
}

InputPrefix.propTypes = {
    prefix: PropTypes.string,
    prefixSize: PropTypes.number,
};
